import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppSmallTabs } from "../../Generic/AppSmallTabs";
import { VisitsTab } from "../MainTypes";

const activeTabMap: { [tab in VisitsTab]: number } = {
  Available: 0,
  Schedule: 1,
};

interface Props {
  activeTab: VisitsTab;
  onClick: (activeTab: VisitsTab) => void;
}

const VisitsTabs = (props: Props) => {
  const handleClick = React.useCallback(
    (tabIndex: number) => {
      switch (tabIndex) {
        case activeTabMap.Available:
          return props.onClick.call(null, "Available");
        case activeTabMap.Schedule:
          return props.onClick.call(null, "Schedule");
        default:
          throw new Error(`unknown tabIndex ${tabIndex}`);
      }
    },
    [props.onClick]
  );

  return (
    <AppSmallTabs
      activeTab={activeTabMap[props.activeTab]}
      tabs={[translate(STRINGS.AVAILABLE), translate(STRINGS.ASSIGNED)]}
      onClick={handleClick}
    />
  );
};

export default VisitsTabs;
